/**
 * Debounces a function by wrapping it such that it can only be invoked once
 * within a certain time frame. Any additional invocations within that timeframe
 * will be ignored.
 *
 * @param func - The function to debounce
 * @param delay - The debounce delay in milliseconds
 * @returns A debounced version of the passed function
 */
export const debounce = (func: Function, delay: number) => {
  let timeoutId: any;
  return (...args: any) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};
